﻿import "pepjs";
import "./jquery-tabcontrol";
import { ready, addCallback, runCallbacks, Res } from "./td";
import { initSidebar } from "./td-sidebar";
import { renderMapView } from "./td-location";
import { initSelectCheckboxLinks } from  "./td-selectall";
import { Ctrl, renderChart } from "./td-ctrl";
import * as MultiRef from "./td-multiref";
import * as RecordPicker from "./td-recordpicker";
import * as RowEdit from "./td-rowedit";
import * as Table from "./td-table";
import { createMarkupToolbar, initMarkupToolbars } from "./td-markup";
import { generateDocument, openDocument, printDocument } from "./td-document";
import { initSignature } from "./td-signature";
import { initRecaptcha } from "./td-recaptcha";
// import { loadCodeMirror6 } from "./codemirror6-loader";
import "./facade-utils";
import "./td-setupform";
import ajax from "./ajax";
import { dbfetch, nativeFetch } from "./dbfetch";

import "./appinit";

if (typeof nativeFetch === "function") {
	window.fetch = dbfetch;
	window.nativeFetch = nativeFetch;
}
window.dbfetch = dbfetch;

export {
	ajax,
	dbfetch as fetch,
	ready,
	addCallback,
	runCallbacks,
	Res,
	Ctrl,
	initSidebar,
	initSignature,
	MultiRef,
	RecordPicker,
	RowEdit,
	Table,
	renderMapView,
	renderChart,
	createMarkupToolbar,
	initMarkupToolbars,
	initSelectCheckboxLinks as initSelectAll,
	generateDocument,
	openDocument,
	printDocument,
	initRecaptcha,
	// loadCodeMirror6
};
